/** Project home, details and build — plus the `projects` role-management namespace. */

export default {
	project: {
		overview: "Overview",
		settings: "Settings",
		build: {
			passing: "Build passing",
			failed: "Build failed",
			idle: "No build yet",
			idleNote: "Build the project to check that it compiles.",
			startedNote: "Compiling the project graph.",
			passingNote: "{files} files in {seconds}s.",
			typeWarnings: "Built with type warnings",
		},
		typecheck: {
			section: "Build",
			title: "Build typecheck",
			hint: "Bundling never checks types. This step does — and what a type error costs the build is yours to set.",
			check: "Check types now",
			clean: "No type errors.",
			resultTitle: "Type errors",
			saved: "Typecheck setting saved.",
			severityLabel: {
				error: "Fail the build",
				warn: "Warn, but build anyway",
				off: "Skip the check",
			},
			severityHelp: {
				error: "Nothing is bundled while a type error remains. The strictest setting, and the right one for a project you keep clean.",
				warn: "The default. The bundle is produced and the errors are reported next to it — so a stale reference somebody left behind cannot stop the project shipping.",
				off: "No typechecking at all. Faster builds, and a broken reference is found at runtime instead.",
			},
		},
		coverage: {
			title: "Translation coverage",
			summary: "{languages} languages · {complete} fully translated",
			empty: "No terminology yet.",
			more: "{count} more language in settings | {count} more languages in settings",
			manage: "Manage languages",
		},
		team: {
			title: "Team",
			/** Under the first few on the team, how many more there are. */
			more: "and {n} more | and {n} more",
		},
		listTitle: "Projects",
		empty: {
			title: "No projects yet",
			hint: "Create your first project to get started.",
		},
		noResults: "No projects match your search.",
		deleteConfirm: "Delete project “{name}”?",
		resultCount: "{n} of {total} projects",
		filesMissing: "Files missing",
		filesMissingNote:
			"This project's files are missing on the server, so it cannot be opened. A server administrator can remove it in the control center's Maintenance.",
		meta: {
			version: "Version",
			created: "Created",
			updated: "Updated",
		},
		sections: {
			members: "Members",
		},
		name: "Project name",
		create: "New project",
		copyId: "Copy project ID",
		search: "Search projects…",
		details: "Project details",
		languages: {
			title: "Supported languages",
			hint: "English is the source language and can't be removed.",
			add: "Add language",
			addHint: "Search for a language to add.",
			addEmpty: "No languages left to add.",
			addDone: "Done",
			remove: "Remove {name}",
			added: "{name} added.",
			removed: "{name} removed.",
		},
	},
	build: {
		buildWip: "Build WIP",
		noProcess: "Add a process first — a project without one cannot be built.",
		building: "Building…",
		success: "Built in {ms}ms · {files} files",
		failed: "Build failed",
		typeWarnings: "Type warnings",
		buildFailed: "Build completed with errors.",
		autoScheduled: "Auto-build scheduled…",
		viewError: "View error details",
		viewTypeWarnings: "View type warnings",
		errorDialogTitle: "Build error",
		typeWarningsDialogTitle: "Type warnings",
		copyError: "Copy error",
		copied: "Copied",
	},
};
